import { combineReducers } from "redux";
import { profileSettingsReducer } from "./components/profile-settings/profile-settings-store";
import { changePasswordReducer } from "./components/change-password/change-password-store";

export const profileReducer = combineReducers({ profileSettingsReducer, changePasswordReducer });
